import { css, Global, } from '@emotion/core';
import React from 'react';

const globalStyles = css`
  * {
    margin: 0;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif, -apple-system, BlinkMacSystemFont, Segoe UI,
      Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans,
      Helvetica Neue, sans-serif, Apple Color Emoji, Segoe UI Emoji,
      Segoe UI Symbol;
  }
  html {
    overflow: hidden;
  }
  body {
    overscroll-behavior-y: contain;
  }
`;

const GlobalComponent = () => (<Global styles={globalStyles} />);
export default GlobalComponent;
